// extracted by mini-css-extract-plugin
module.exports = {"previewText":"Zoom_previewText__3TayR","light":"Zoom_light__1X4M_"};